import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  CircularProgress,
} from '@mui/material';
import { useNotification } from '../../contexts/NotificationContext';
import PageHeader from '../../components/common/PageHeader';
import CitaForm from '../../components/citas/CitaForm';
import citaService from '../../services/citaService';

const CitaEdit = () => {
  const { id } = useParams();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(true);
  const [cita, setCita] = useState(null);
  
  // Cargar datos de la cita
  useEffect(() => {
    const fetchCita = async () => {
      setLoading(true);
      try {
        const response = await citaService.getCita(id);
        
        // Preparar datos para el formulario
        const citaData = response.data;
        
        // Convertir fecha de string a objeto Date
        if (citaData.fecha) {
          citaData.fecha = new Date(citaData.fecha);
        }
        
        // Convertir horas de string a objetos Date
        if (citaData.hora_inicio) {
          const [hours, minutes] = citaData.hora_inicio.split(':');
          const horaInicio = new Date();
          horaInicio.setHours(parseInt(hours, 10));
          horaInicio.setMinutes(parseInt(minutes, 10));
          citaData.hora_inicio = horaInicio;
        }
        
        if (citaData.hora_fin) {
          const [hours, minutes] = citaData.hora_fin.split(':');
          const horaFin = new Date();
          horaFin.setHours(parseInt(hours, 10));
          horaFin.setMinutes(parseInt(minutes, 10));
          citaData.hora_fin = horaFin;
        }
        
        setCita(citaData);
      } catch (error) {
        console.error('Error fetching appointment:', error);
        showNotification(
          'Error al cargar los datos de la cita',
          'error'
        );
      } finally {
        setLoading(false);
      }
    };
    
    fetchCita();
  }, [id, showNotification]);
  
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" my={5}>
        <CircularProgress />
      </Box>
    );
  }
  
  return (
    <Box sx={{ flexGrow: 1 }}>
      <PageHeader
        title="Editar Cita"
        breadcrumbs={[
          { text: 'Dashboard', to: '/dashboard' },
          { text: 'Citas', to: '/citas' },
          { text: `Editar Cita #${id}` }
        ]}
      />
      
      <CitaForm initialData={cita} isEdit={true} />
    </Box>
  );
};

export default CitaEdit;